import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.18_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.18_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["ContactForm"] */ "/vercel/path0/src/app/(marketing)/kontakt/contact-form.js");
;
import(/* webpackMode: "eager", webpackExports: ["Facts"] */ "/vercel/path0/src/app/(marketing)/ueber-uns/facts.js");
